import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import {
    OfferPlacementAnalytics,
    TARIFFICATOR_BILLING_PRODUCT_ID,
} from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface OfferAnalyticsData {
    buttonText: string;
    offer: Offer;
    entityType?: string;
}

type OfferAnalytics = OfferPlacementAnalytics<OfferAnalyticsData>;

export function createOfferAnalytics(eventSender: AnalyticsSender): OfferAnalytics {
    let data: OfferAnalyticsData | undefined;

    const getCommonData = ({ buttonText, offer }: OfferAnalyticsData) => {
        const offerTariffName = offer.catalogCompositeOffer.tariffOffer?.tariff?.name ?? '';
        const offerOptionNames = offer.catalogCompositeOffer.optionOffers?.[0]?.option?.name ?? '';

        return {
            buttonText,
            offerTitle: getOfferTitle(offer),
            offerTariffName,
            offerOptionNames,
            billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
            billingProductIds: offer.billingProductIds,
        };
    };

    return {
        setData(value) {
            data = value;
        },
        showed() {
            if (!data) return;

            const { offer, entityType } = data;

            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                ...getCommonData(data),
                show: offer.offerPositionsData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
        navigated() {
            if (!data) return;

            const { offer } = data;

            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                ...getCommonData(data),
                click: offer.offerPositionsData,
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            if (!data) return;

            const { entityType } = data;

            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                ...getCommonData(data),
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
    };
}
